module.exports = __webpack_public_path__ + "img/CTPAT-sf.b8660bf9.png";